const translations = {
    "en": {
        "login": "Connect",
        "register": "Register",
        "support": "Support",
        "privacy": "Privacy Policy",
        "terms": "Terms of Service",
        "show_notification_title": "Turn On Notifications",
        "show_notification_description": "To receive notifications from the game, turn them on in the settings. If you don't know how, please view the <a href='https://clockmaker.zendesk.com/hc/en-us/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>instructions.</a>",
        "show_notification_active": "To receive notifications from the game, turn them on in the settings. If you don't know how, please view the instructions.",
        "show_notification_denied": "To receive notifications from the game, turn them on in the settings. If you don't know how, please view the instructions.",
        "install": "Install",
        "language": "Language",
        "yes": "Yes",
        "no": "No"
    },
    "es": {
        "login": "Conectar",
        "register": "Registrarse",
        "support": "Soporte",
        "privacy": "Política de privacidad",
        "terms": "Términos y condiciones de uso",
        "show_notification_title": "Activa las notificaciones",
        "show_notification_description": "Para recibir notificaciones del juego, actívalas en los ajustes. Si no sabes hacerlo, lee las <a href='https://clockmaker.zendesk.com/hc/es/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>instrucciones</a>.",
        "install": "Instalar",
        "language": "Idioma",
        "yes": "Sí",
        "no": "No"
    },
    "it": {
        "login": "Connetti",
        "register": "Registrati",
        "support": "Assistenza",
        "privacy": "Informativa sulla privacy",
        "terms": "Condizioni d'uso",
        "show_notification_title": "Attiva le notifiche",
        "show_notification_description": "Per ricevere le notifiche dal gioco, attivale nelle impostazioni. Se non sai come fare, consulta le <a href='https://clockmaker.zendesk.com/hc/it/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>istruzioni</a>.",
        "install": "Installa",
        "language": "Lingua",
        "yes": "Sì",
        "no": "No"
    },
    "pt_br": {
        "login": "Conectar",
        "register": "Registrar",
        "support": "Suporte",
        "privacy": "Política de Privacidade",
        "terms": "Termos de Serviço",
        "show_notification_title": "Ativar notificações",
        "show_notification_description": "Para receber notificações do jogo, ative-as nas configurações. Se não souber como, consulte as <a href='https://clockmaker.zendesk.com/hc/pt-br/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>instruções</a>.",
        "install": "Instalar",
        "language": "Idioma",
        "yes": "Sim",
        "no": "Não"
    },
    "nl": {
        "login": "Verbinden",
        "register": "Registreren",
        "support": "Ondersteuning",
        "privacy": "Privacybeleid",
        "terms": "Servicevoorwaarden",
        "show_notification_title": "Schakel meldingen in",
        "show_notification_description": "Om meldingen van het spel te ontvangen, moet je ze inschakelen in de instellingen. Als je niet weet hoe dit moet, kun je de <a href='https://clockmaker.zendesk.com/hc/en-us/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>instructies</a> doornemen.",
        "install": "Installeren",
        "language": "Taal",
        "yes": "Ja",
        "no": "Nee"
    },
    "de": {
        "login": "Verbinden",
        "register": "Registrieren",
        "support": "Support",
        "privacy": "Datenschutzerklärung",
        "terms": "Nutzungsbedingungen",
        "show_notification_title": "Aktiviere Benachrichtigungen",
        "show_notification_description": "Um Benachrichtigungen vom Spiel zu erhalten, aktiviere sie in den Einstellungen. Wenn du nicht weißt, wie das geht, sieh dir bitte die <a href='https://clockmaker.zendesk.com/hc/de/articles/24660426522001-Aktiviere-Browser-Benachrichtigungen' target='_blank'>Anweisungen an</a>.",
        "install": "Installieren",
        "language": "Sprache",
        "yes": "Ja",
        "no": "Nein"
    },
    "fr": {
        "login": "Connexion",
        "register": "S'enregistrer",
        "support": "Assistance",
        "privacy": "Charte de confidentialité",
        "terms": "Conditions d'utilisation",
        "show_notification_title": "Active les notifications",
        "show_notification_description": "Pour recevoir des notifications du jeu, active-les dans les paramètres. Si tu ne sais pas comment faire, nous t'invitons à consulter les <a href='https://clockmaker.zendesk.com/hc/fr/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>instructions</a>.",
        "install": "Installer",
        "language": "Langue",
        "yes": "Oui",
        "no": "Non"
    },
    "pt": {
        "login": "Ligar",
        "register": "Registar",
        "support": "Assistência",
        "privacy": "Política de Privacidade",
        "terms": "Termos de Serviço",
        "show_notification_title": "Ativar notificações",
        "show_notification_description": "Para receberes notificações do jogo, ativa-as nas definições. Se não souberes como, consulta as <a href='https://clockmaker.zendesk.com/hc/pt-br/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>instruções</a>.",
        "install": "Instalar",
        "language": "Idioma",
        "yes": "Sim",
        "no": "Não"
    },
    "ru": {
        "login": "Войти",
        "register": "Зарегистрироваться",
        "support": "Поддержка",
        "privacy": "Политика конфиденциальности",
        "terms": "Условия пользования",
        "show_notification_title": "Включите уведомления",
        "show_notification_description": "Чтобы получать уведомления от игры, включите их в настройках. Если вы не знаете, как это сделать, посмотрите <a href='https://clockmaker.zendesk.com/hc/ru/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>инструкцию</a>.",
        "show_notification_active": "Уведомления включены.",
        "show_notification_denied": "Чтобы получать уведомления от игры, включите их в настройках. Если вы не знаете, как это сделать, посмотрите инструкцию.",
        "install": "Установить",
        "language": "Язык",
        "yes": "Да",
        "no": "Нет"
    },
    "ko": {
        "login": "연결",
        "register": "등록",
        "support": "고객지원",
        "privacy": "개인정보 보호정책",
        "terms": "서비스 약관",
        "show_notification_title": "알림을 켜세요",
        "show_notification_description": "게임에서 알림을 받으려면 설정에서 알림을 켜세요. <a href='https://clockmaker.zendesk.com/hc/ko/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>방법을 모르면 설명을 확인해 주시기 바랍니다</a>.",
        "install": "설치",
        "language": "언어",
        "yes": "예",
        "no": "아니오"
    },
    "ja": {
        "login": "接続する",
        "register": "登録する",
        "support": "サポート",
        "privacy": "プライバシーポリシー",
        "terms": "利用規約",
        "show_notification_title": "通知をオンにしましょう",
        "show_notification_description": "ゲームからの通知を受け取るには、設定から通知をオンにする必要があります。ご存知ない場合は<a href='https://clockmaker.zendesk.com/hc/jp/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>手順をご覧</a>ください。",
        "install": "インストールする",
        "language": "言語",
        "yes": "はい",
        "no": "いいえ"
    },
    "zh": {
        "login": "连接",
        "register": "注册",
        "support": "支持",
        "privacy": "隐私政策",
        "terms": "服务条款",
        "show_notification_title": "打开通知",
        "show_notification_description": "你可以在设置中开启并接收游戏通知。<a href='https://clockmaker.zendesk.com/hc/zh-cn/articles/24660426522001-Enabling-Browser-Notifications' target='_blank'>若不了解操作方法，请查阅相关指南。</a>",
        "install": "安装",
        "language": "语言",
        "yes": "是",
        "no": "否"
    }
};

const translations2 = {
    "login": {
        "en": "Connect",
        "es": "Conectar",
        "it": "Connetti",
        "pt_br": "Conectar",
        "nl": "Verbinden",
        "de": "Verbinden",
        "fr": "Connexion",
        "pt": "Ligar",
        "ru": "Войти",
        "ko": "연결",
        "ja": "接続する",
        "zh": "连接",
        "pl": "Połącz",
        "ua": "Увійти"
    },
    "register": {
        "en": "Register",
        "es": "Registrarse",
        "it": "Registrati",
        "pt_br": "Registrar",
        "nl": "Registreren",
        "de": "Registrieren",
        "fr": "S'enregistrer",
        "pt": "Registar",
        "ru": "Зарегистрироваться",
        "ko": "등록",
        "ja": "登録する",
        "zh": "注册",
        "pl": "Zarejestruj się",
        "ua": "Зареєструватися"
    },
    "support": {
        "en": "Support",
        "es": "Soporte",
        "it": "Assistenza",
        "pt_br": "Suporte",
        "nl": "Ondersteuning",
        "de": "Support",
        "fr": "Assistance",
        "pt": "Assistência",
        "ru": "Поддержка",
        "ko": "고객지원",
        "ja": "サポート",
        "zh": "支持",
        "pl": "Wsparcie",
        "ua": "Підтримка"
    },
    "privacy": {
        "en": "Privacy Policy",
        "es": "Política de privacidad",
        "it": "Informativa sulla privacy",
        "pt_br": "Política de Privacidade",
        "nl": "Privacybeleid",
        "de": "Datenschutzerklärung",
        "fr": "Charte de confidentialité",
        "pt": "Política de Privacidade",
        "ru": "Политика конфиденциальности",
        "ko": "개인정보 보호정책",
        "ja": "プライバシーポリシー",
        "zh": "隐私政策",
        "pl": "Polityka prywatności",
        "ua": "Політика конфіденційності"
    },
    "terms": {
        "en": "Terms of Service",
        "es": "Términos y condiciones de uso",
        "it": "Condizioni d'uso",
        "pt_br": "Termos de Serviço",
        "nl": "Servicevoorwaarden",
        "de": "Nutzungsbedingungen",
        "fr": "Conditions d'utilisation",
        "pt": "Termos de Serviço",
        "ru": "Условия пользования",
        "ko": "서비스 약관",
        "ja": "利用規約",
        "zh": "服务条款",
        "pl": "Warunki korzystania z usługi",
        "ua": "Умови використання"
    },
    "show_notification_title": {
        "en": "Turn On Notifications",
        "es": "Activa las notificaciones",
        "it": "Attiva le notifiche",
        "pt_br": "Ativar notificações",
        "nl": "Schakel meldingen in",
        "de": "Aktiviere Benachrichtigungen",
        "fr": "Active les notifications",
        "pt": "Ativar notificações",
        "ru": "Включите уведомления",
        "ko": "알림을 켜세요",
        "ja": "通知をオンにしましょう",
        "zh": "打开通知",
        "pl": "Włącz powiadomienia",
        "ua": "Увімкніть сповіщення"
    },
    "show_notification_description": {
        "en": "To receive notifications from the game, turn them on in the settings. If you don't know how, please view the instructions.",
        "es": "Para recibir notificaciones del juego, actívalas en los ajustes. Si no sabes hacerlo, lee las instrucciones.",
        "it": "Per ricevere le notifiche dal gioco, attivale nelle impostazioni. Se non sai come fare, consulta le istruzioni.",
        "pt_br": "Para receber notificações do jogo, ative-as nas configurações. Se não souber como, consulte as instruções.",
        "nl": "Om meldingen van het spel te ontvangen, moet je ze inschakelen in de instellingen. Als je niet weet hoe dit moet, kun je de instructies doornemen.",
        "de": "Um Benachrichtigungen vom Spiel zu erhalten, aktiviere sie in den Einstellungen. Wenn du nicht weißt, wie das geht, sieh dir bitte die Anweisungen an.",
        "fr": "Pour recevoir des notifications du jeu, active-les dans les paramètres. Si tu ne sais pas comment faire, nous t'invitons à consulter les instructions.",
        "pt": "Para receberes notificações do jogo, ativa-as nas definições. Se não souberes como, consulta as instruções.",
        "ru": "Чтобы получать уведомления от игры, включите их в настройках. Если вы не знаете, как это сделать, посмотрите инструкцию.",
        "ko": "게임에서 알림을 받으려면 설정에서 알림을 켜세요. 방법을 모르면 설명을 확인해 주시기 바랍니다.",
        "ja": "ゲームからの通知を受け取るには、設定から通知をオンにする必要があります。ご存知ない場合は手順をご覧ください。",
        "zh": "你可以在设置中开启并接收游戏通知。若不了解操作方法，请查阅相关指南。",
        "pl": "Aby otrzymywać powiadomienia z gry, włącz je w ustawieniach. Jeśli nie wiesz jak to zrobić, zapoznaj się z instrukcją.",
        "ua": "Щоб отримувати сповіщення від гри, увімкніть їх у налаштуваннях. Якщо ви не знаєте, як це зробити, перегляньте інструкцію."
    },
    "show_notification_active": {
        "en": "To receive notifications from the game, turn them on in the settings. If you don't know how, please view the instructions.",
        "ru": "Уведомления включены.",
        "pl": "Powiadomienia są włączone.",
        "ua": "Сповіщення увімкнено."
    },
    "show_notification_denied": {
        "en": "To receive notifications from the game, turn them on in the settings. If you don't know how, please view the instructions.",
        "ru": "Чтобы получать уведомления от игры, включите их в настройках. Если вы не знаете, как это сделать, посмотрите инструкцию.",
        "pl": "Aby otrzymywać powiadomienia z gry, włącz je w ustawieniach. Jeśli nie wiesz jak to zrobić, zapoznaj się z instrukcją.",
        "ua": "Щоб отримувати сповіщення від гри, увімкніть їх у налаштуваннях. Якщо ви не знаєте, як це зробити, перегляньте інструкцію."
    },
    "install": {
        "en": "Install",
        "es": "Instalar",
        "it": "Installa",
        "pt_br": "Instalar",
        "nl": "Installeren",
        "de": "Installieren",
        "fr": "Installer",
        "pt": "Instalar",
        "ru": "Установить",
        "ko": "설치",
        "ja": "インストールする",
        "zh": "安装",
        "pl": "Instaluj",
        "ua": "Встановити"
    },
    "language": {
        "en": "Language",
        "es": "Idioma",
        "it": "Lingua",
        "pt_br": "Idioma",
        "nl": "Taal",
        "de": "Sprache",
        "fr": "Langue",
        "pt": "Idioma",
        "ru": "Язык",
        "ko": "언어",
        "ja": "言語",
        "zh": "语言",
        "pl": "Język",
        "ua": "Мова"
    },
    "yes": {
        "en": "Yes",
        "es": "Sí",
        "it": "Sì",
        "pt_br": "Sim",
        "nl": "Ja",
        "de": "Ja",
        "fr": "Oui",
        "pt": "Sim",
        "ru": "Да",
        "ko": "예",
        "ja": "はい",
        "zh": "是",
        "pl": "Tak",
        "ua": "Так"
    },
    "no": {
        "en": "No",
        "es": "No",
        "it": "No",
        "pt_br": "Não",
        "nl": "Nee",
        "de": "Nein",
        "fr": "Non",
        "pt": "Não",
        "ru": "Нет",
        "ko": "아니오",
        "ja": "いいえ",
        "zh": "否",
        "pl": "Nie",
        "ua": "Ні"
    },
    "loading": {
        en: "Loading",
        es: "Cargando",
        it: "Caricamento",
        pt_br: "Carregando",
        nl: "Laden",
        de: "Laden",
        fr: "Chargement",
        pt: "A carregar",
        ru: "Загрузка",
        ko: "로딩 중",
        ja: "ロード中",
        zh: "加载中",
        pl: "Ładowanie",
        ua: "Завантаження"
    },
    "game_start_error": {
        "en": "Unable to start the game on a mobile device. Please select a suitable platform to install.",
        "es": "No se puede iniciar el juego en un dispositivo móvil. Por favor, selecciona una plataforma adecuada para instalar.",
        "it": "Impossibile avviare il gioco su un dispositivo mobile. Seleziona una piattaforma adatta per l'installazione.",
        "pt_br": "Não é possível iniciar o jogo em um dispositivo móvel. Por favor, selecione uma plataforma adequada para instalar.",
        "nl": "Het spel kan niet worden gestart op een mobiel apparaat. Selecteer een geschikt platform om te installeren.",
        "de": "Das Spiel kann auf einem mobilen Gerät nicht gestartet werden. Bitte wählen Sie eine geeignete Plattform zur Installation aus.",
        "fr": "Impossible de démarrer le jeu sur un appareil mobile. Veuillez sélectionner une plateforme appropriée pour l'installation.",
        "pt": "Não é possível iniciar o jogo num dispositivo móvel. Por favor, selecione uma plataforma adequada para instalar.",
        "ru": "Невозможно запустить игру на мобильном устройстве. Пожалуйста, выберите подходящую платформу для установки.",
        "ko": "모바일 기기에서 게임을 시작할 수 없습니다. 설치할 적합한 플랫폼을 선택해 주세요.",
        "ja": "モバイルデバイスでゲームを開始できません。適切なプラットフォームを選択してください。",
        "zh": "无法在移动设备上启动游戏。请选择适合安装的平台。",
        "pl": "Nie można uruchomić gry na urządzeniu mobilnym. Wybierz odpowiednią platformę do instalacji.",
        "ua": "Неможливо запустити гру на мобільному пристрої. Будь ласка, виберіть відповідну платформу для встановлення."
    },
    'no_close':  {
        en: "No, thank you",
        es: "No, gracias",
        it: "No, grazie",
        pt_br: "Não, obrigado",
        nl: "Nee, bedankt",
        de: "Nein, danke",
        fr: "Non, merci",
        pt: "Não, obrigado",
        ru: "Нет, спасибо",
        ko: "괜찮아요",
        ja: "表示しない",
        zh: "不必了",
        pl: "Nie, dziękuję",
        ua: "Ні, дякую"
    },
    'show_instructions':  {
        en: "See instructions",
        es: "Ver instrucciones",
        it: "Vedi le istruzioni",
        pt_br: "Ver instruções",
        nl: "Instructies bekijken",
        de: "Anweisungen ansehen",
        fr: "Voir les instructions",
        pt: "Ver instruções",
        ru: "Смотреть инструкцию",
        ko: "지침 보기",
        ja: "説明を表示する",
        zh: "查看说明",
        pl: "Zobacz instrukcję",
        ua: "Переглянути інструкцію"
    },
    'show_instructions_link': {
        "en": "https://clockmaker.zendesk.com/hc/en-us/articles/24660426522001-Enabling-Browser-Notifications",
        "es": "https://clockmaker.zendesk.com/hc/es/articles/24660426522001-Enabling-Browser-Notifications",
        "it": "https://clockmaker.zendesk.com/hc/it/articles/24660426522001-Enabling-Browser-Notifications",
        "pt_br": "https://clockmaker.zendesk.com/hc/pt-br/articles/24660426522001-Enabling-Browser-Notifications",
        "nl": "https://clockmaker.zendesk.com/hc/en-us/articles/24660426522001-Enabling-Browser-Notifications",
        "de": "https://clockmaker.zendesk.com/hc/de/articles/24660426522001-Enabling-Browser-Notifications",
        "fr": "https://clockmaker.zendesk.com/hc/fr/articles/24660426522001-Enabling-Browser-Notifications",
        "pt": "https://clockmaker.zendesk.com/hc/pt-br/articles/24660426522001-Enabling-Browser-Notifications",
        "ru": "https://clockmaker.zendesk.com/hc/ru/articles/24660426522001-Enabling-Browser-Notifications",
        "ko": "https://clockmaker.zendesk.com/hc/ko/articles/24660426522001-Enabling-Browser-Notifications",
        "ja": "https://clockmaker.zendesk.com/hc/ja/articles/24660426522001-Enabling-Browser-Notifications",
        "zh": "https://clockmaker.zendesk.com/hc/zh-cn/articles/24660426522001-Enabling-Browser-Notifications",
        "pl": "https://clockmaker.zendesk.com/hc/en-us/articles/24660426522001-Enabling-Browser-Notifications",
        "ua": "https://clockmaker.zendesk.com/hc/en-us/articles/24660426522001-Enabling-Browser-Notifications"
    },

    // Firebase Auth (диалог входа)
    "auth_title": {
        "en": "Sign in to Clockmaker",
        "es": "Inicia sesión en Clockmaker",
        "it": "Accedi a Clockmaker",
        "pt_br": "Entrar no Clockmaker",
        "nl": "Log in bij Clockmaker",
        "de": "Bei Clockmaker anmelden",
        "fr": "Connexion à Clockmaker",
        "pt": "Iniciar sessão no Clockmaker",
        "ru": "Вход в Clockmaker",
        "ko": "Clockmaker 로그인",
        "ja": "Clockmakerにログイン",
        "zh": "登录 Clockmaker",
        "pl": "Zaloguj się do Clockmaker",
        "ua": "Вхід у Clockmaker"
    },
    "auth_subtitle": {
        "en": "Keep your progress on every device",
        "es": "Conserva tu progreso en todos tus dispositivos",
        "it": "Conserva i tuoi progressi su tutti i dispositivi",
        "pt_br": "Mantenha seu progresso em todos os dispositivos",
        "nl": "Behoud je voortgang op al je apparaten",
        "de": "Behalte deinen Fortschritt auf allen Geräten",
        "fr": "Conservez votre progression sur tous vos appareils",
        "pt": "Mantenha o seu progresso em todos os dispositivos",
        "ru": "Сохраните прогресс на всех устройствах",
        "ko": "모든 기기에서 진행 상황을 유지하세요",
        "ja": "すべてのデバイスで進行状況を引き継げます",
        "zh": "在所有设备上保存你的进度",
        "pl": "Zachowaj postępy na wszystkich urządzeniach",
        "ua": "Зберігайте прогрес на всіх пристроях"
    },
    "auth_google": {
        "en": "Continue with Google",
        "es": "Continuar con Google",
        "it": "Continua con Google",
        "pt_br": "Continuar com o Google",
        "nl": "Doorgaan met Google",
        "de": "Weiter mit Google",
        "fr": "Continuer avec Google",
        "pt": "Continuar com o Google",
        "ru": "Продолжить с Google",
        "ko": "Google로 계속하기",
        "ja": "Googleで続行",
        "zh": "使用 Google 继续",
        "pl": "Kontynuuj z Google",
        "ua": "Продовжити з Google"
    },
    "auth_facebook": {
        "en": "Continue with Facebook",
        "es": "Continuar con Facebook",
        "it": "Continua con Facebook",
        "pt_br": "Continuar com o Facebook",
        "nl": "Doorgaan met Facebook",
        "de": "Weiter mit Facebook",
        "fr": "Continuer avec Facebook",
        "pt": "Continuar com o Facebook",
        "ru": "Продолжить с Facebook",
        "ko": "Facebook으로 계속하기",
        "ja": "Facebookで続行",
        "zh": "使用 Facebook 继续",
        "pl": "Kontynuuj z Facebookiem",
        "ua": "Продовжити з Facebook"
    },
    "auth_or": {
        "en": "or",
        "es": "o",
        "it": "oppure",
        "pt_br": "ou",
        "nl": "of",
        "de": "oder",
        "fr": "ou",
        "pt": "ou",
        "ru": "или",
        "ko": "또는",
        "ja": "または",
        "zh": "或",
        "pl": "lub",
        "ua": "або"
    },
    "auth_email": {
        "en": "Email",
        "es": "Correo electrónico",
        "it": "Email",
        "pt_br": "E-mail",
        "nl": "E-mail",
        "de": "E-Mail",
        "fr": "E-mail",
        "pt": "E-mail",
        "ru": "Email",
        "ko": "이메일",
        "ja": "メールアドレス",
        "zh": "电子邮箱",
        "pl": "E-mail",
        "ua": "Email"
    },
    "auth_password": {
        "en": "Password",
        "es": "Contraseña",
        "it": "Password",
        "pt_br": "Senha",
        "nl": "Wachtwoord",
        "de": "Passwort",
        "fr": "Mot de passe",
        "pt": "Palavra-passe",
        "ru": "Пароль",
        "ko": "비밀번호",
        "ja": "パスワード",
        "zh": "密码",
        "pl": "Hasło",
        "ua": "Пароль"
    },
    "auth_sign_in": {
        "en": "Log in",
        "es": "Iniciar sesión",
        "it": "Accedi",
        "pt_br": "Entrar",
        "nl": "Inloggen",
        "de": "Anmelden",
        "fr": "Se connecter",
        "pt": "Iniciar sessão",
        "ru": "Войти",
        "ko": "로그인",
        "ja": "ログイン",
        "zh": "登录",
        "pl": "Zaloguj się",
        "ua": "Увійти"
    },
    "auth_sign_up": {
        "en": "Sign up",
        "es": "Registrarse",
        "it": "Registrati",
        "pt_br": "Registrar",
        "nl": "Registreren",
        "de": "Registrieren",
        "fr": "S'enregistrer",
        "pt": "Registar",
        "ru": "Регистрация",
        "ko": "등록",
        "ja": "登録する",
        "zh": "注册",
        "pl": "Zarejestruj się",
        "ua": "Реєстрація"
    },
    "auth_create_account": {
        "en": "Create account",
        "es": "Crear cuenta",
        "it": "Crea un account",
        "pt_br": "Criar conta",
        "nl": "Account aanmaken",
        "de": "Konto erstellen",
        "fr": "Créer un compte",
        "pt": "Criar conta",
        "ru": "Создать аккаунт",
        "ko": "계정 만들기",
        "ja": "アカウントを作成",
        "zh": "创建账号",
        "pl": "Utwórz konto",
        "ua": "Створити акаунт"
    },
    "auth_have_account": {
        "en": "Already have an account? Sign in",
        "es": "¿Ya tienes una cuenta? Inicia sesión",
        "it": "Hai già un account? Accedi",
        "pt_br": "Já tem uma conta? Entrar",
        "nl": "Heb je al een account? Log in",
        "de": "Du hast schon ein Konto? Anmelden",
        "fr": "Vous avez déjà un compte ? Connectez-vous",
        "pt": "Já tem uma conta? Iniciar sessão",
        "ru": "Уже есть аккаунт? Войти",
        "ko": "이미 계정이 있으신가요? 로그인",
        "ja": "すでにアカウントをお持ちですか？ログイン",
        "zh": "已有账号？登录",
        "pl": "Masz już konto? Zaloguj się",
        "ua": "Вже є акаунт? Увійти"
    },
    "auth_no_account": {
        "en": "No account yet? Create one",
        "es": "¿Aún no tienes cuenta? Crea una",
        "it": "Non hai ancora un account? Creane uno",
        "pt_br": "Ainda não tem conta? Crie uma",
        "nl": "Nog geen account? Maak er een aan",
        "de": "Noch kein Konto? Jetzt erstellen",
        "fr": "Pas encore de compte ? Créez-en un",
        "pt": "Ainda não tem conta? Crie uma",
        "ru": "Нет аккаунта? Создать",
        "ko": "계정이 없으신가요? 새로 만들기",
        "ja": "アカウントをお持ちでないですか？作成する",
        "zh": "还没有账号？立即创建",
        "pl": "Nie masz konta? Utwórz je",
        "ua": "Немає акаунта? Створити"
    },
    "auth_forgot": {
        "en": "Forgot password?",
        "es": "¿Olvidaste tu contraseña?",
        "it": "Password dimenticata?",
        "pt_br": "Esqueceu sua senha?",
        "nl": "Wachtwoord vergeten?",
        "de": "Passwort vergessen?",
        "fr": "Mot de passe oublié ?",
        "pt": "Esqueceu-se da palavra-passe?",
        "ru": "Забыли пароль?",
        "ko": "비밀번호를 잊으셨나요?",
        "ja": "パスワードをお忘れですか？",
        "zh": "忘记密码？",
        "pl": "Nie pamiętasz hasła?",
        "ua": "Забули пароль?"
    },
    "auth_forgot_title": {
        "en": "Recover password",
        "es": "Recuperar contraseña",
        "it": "Recupera la password",
        "pt_br": "Recuperar senha",
        "nl": "Wachtwoord herstellen",
        "de": "Passwort zurücksetzen",
        "fr": "Récupérer le mot de passe",
        "pt": "Recuperar palavra-passe",
        "ru": "Восстановление пароля",
        "ko": "비밀번호 찾기",
        "ja": "パスワードの再設定",
        "zh": "找回密码",
        "pl": "Odzyskiwanie hasła",
        "ua": "Відновлення пароля"
    },
    "auth_forgot_descr": {
        "en": "You will receive an email with a link to reset your password.",
        "es": "Recibirás un correo con un enlace para restablecer tu contraseña.",
        "it": "Riceverai un'email con un link per reimpostare la password.",
        "pt_br": "Você receberá um e-mail com um link para redefinir sua senha.",
        "nl": "Je ontvangt een e-mail met een link om je wachtwoord opnieuw in te stellen.",
        "de": "Du erhältst eine E-Mail mit einem Link zum Zurücksetzen deines Passworts.",
        "fr": "Vous recevrez un e-mail contenant un lien pour réinitialiser votre mot de passe.",
        "pt": "Vai receber um e-mail com uma ligação para redefinir a sua palavra-passe.",
        "ru": "Вы получите письмо со ссылкой для сброса пароля.",
        "ko": "비밀번호를 재설정할 수 있는 링크를 이메일로 보내 드립니다.",
        "ja": "パスワードを再設定するためのリンクをメールでお送りします。",
        "zh": "我们会向你的邮箱发送重置密码的链接。",
        "pl": "Otrzymasz e-mail z linkiem do zresetowania hasła.",
        "ua": "Ви отримаєте лист із посиланням для скидання пароля."
    },
    "auth_reset_send": {
        "en": "Send reset link",
        "es": "Enviar enlace",
        "it": "Invia il link",
        "pt_br": "Enviar link",
        "nl": "Link versturen",
        "de": "Link senden",
        "fr": "Envoyer le lien",
        "pt": "Enviar ligação",
        "ru": "Отправить ссылку",
        "ko": "링크 보내기",
        "ja": "リンクを送信",
        "zh": "发送链接",
        "pl": "Wyślij link",
        "ua": "Надіслати посилання"
    },
    "auth_reset_sent": {
        "en": "It\u2019s okay, we all forget sometimes. Just change your password using the instructions we sent to {email}.",
        "es": "No pasa nada, a todos se nos olvida alguna vez. Cambia tu contraseña siguiendo las instrucciones que enviamos a {email}.",
        "it": "Non preoccuparti, capita a tutti di dimenticare. Cambia la password seguendo le istruzioni che abbiamo inviato a {email}.",
        "pt_br": "Tudo bem, todo mundo esquece de vez em quando. Basta mudar sua senha seguindo as instruções que enviamos para {email}.",
        "nl": "Geen probleem, iedereen vergeet weleens iets. Wijzig je wachtwoord met de instructies die we naar {email} hebben gestuurd.",
        "de": "Kein Problem, das passiert jedem mal. Ändere dein Passwort einfach mit der Anleitung, die wir an {email} geschickt haben.",
        "fr": "Pas de souci, ça arrive à tout le monde. Changez votre mot de passe en suivant les instructions envoyées à {email}.",
        "pt": "Não faz mal, acontece a todos. Mude a sua palavra-passe seguindo as instruções que enviámos para {email}.",
        "ru": "Ничего страшного, все иногда забывают. Просто измените пароль по инструкции, которую мы отправили на {email}.",
        "ko": "괜찮아요, 누구나 가끔 잊어버리죠. {email}(으)로 보낸 안내에 따라 비밀번호를 변경하세요.",
        "ja": "大丈夫です、誰にでもあることです。{email} にお送りした手順に従ってパスワードを変更してください。",
        "zh": "没关系，谁都有忘记的时候。请按照我们发送到 {email} 的说明修改密码。",
        "pl": "Nic się nie stało, każdemu się zdarza. Zmień hasło zgodnie z instrukcją, którą wysłaliśmy na adres {email}.",
        "ua": "Нічого страшного, усі іноді забувають. Просто змініть пароль за інструкцією, яку ми надіслали на {email}."
    },
    "auth_verification_sent": {
        "en": "We sent a verification link to your email.",
        "es": "Te hemos enviado un enlace de verificación a tu correo.",
        "it": "Ti abbiamo inviato un link di verifica via email.",
        "pt_br": "Enviamos um link de verificação para seu e-mail.",
        "nl": "We hebben een verificatielink naar je e-mail gestuurd.",
        "de": "Wir haben dir einen Bestätigungslink per E-Mail geschickt.",
        "fr": "Nous avons envoyé un lien de vérification à votre adresse e-mail.",
        "pt": "Enviámos uma ligação de verificação para o seu e-mail.",
        "ru": "Ссылка для подтверждения email отправлена.",
        "ko": "인증 링크를 이메일로 보냈습니다.",
        "ja": "確認用のリンクをメールで送信しました。",
        "zh": "我们已将验证链接发送到你的邮箱。",
        "pl": "Wysłaliśmy link weryfikacyjny na Twój e-mail.",
        "ua": "Посилання для підтвердження email надіслано."
    },
    "auth_back": {
        "en": "Back to Login",
        "es": "Volver al inicio de sesión",
        "it": "Torna all'accesso",
        "pt_br": "Voltar para o login",
        "nl": "Terug naar inloggen",
        "de": "Zurück zur Anmeldung",
        "fr": "Retour à la connexion",
        "pt": "Voltar ao início de sessão",
        "ru": "Назад к Авторизации",
        "ko": "로그인으로 돌아가기",
        "ja": "ログインに戻る",
        "zh": "返回登录",
        "pl": "Powrót do logowania",
        "ua": "Назад до входу"
    },
    "auth_logout": {
        "en": "Log out",
        "es": "Cerrar sesión",
        "it": "Esci",
        "pt_br": "Sair",
        "nl": "Uitloggen",
        "de": "Abmelden",
        "fr": "Se déconnecter",
        "pt": "Terminar sessão",
        "ru": "Выйти",
        "ko": "로그아웃",
        "ja": "ログアウト",
        "zh": "退出登录",
        "pl": "Wyloguj się",
        "ua": "Вийти"
    },
    "auth_legacy_title": {
        "en": "Sign in again",
        "es": "Inicia sesión de nuevo",
        "it": "Accedi di nuovo",
        "pt_br": "Entre novamente",
        "nl": "Log opnieuw in",
        "de": "Bitte erneut anmelden",
        "fr": "Reconnectez-vous",
        "pt": "Inicie sessão novamente",
        "ru": "Войдите заново",
        "ko": "다시 로그인해 주세요",
        "ja": "もう一度ログインしてください",
        "zh": "请重新登录",
        "pl": "Zaloguj się ponownie",
        "ua": "Увійдіть знову"
    },
    "auth_legacy_text": {
        "en": "We have updated the sign-in system. Please sign in again with the same email or social account to keep your progress.",
        "es": "Hemos actualizado el sistema de inicio de sesión. Inicia sesión de nuevo con el mismo correo o la misma red social para conservar tu progreso.",
        "it": "Abbiamo aggiornato il sistema di accesso. Accedi di nuovo con la stessa email o lo stesso social per conservare i tuoi progressi.",
        "pt_br": "Atualizamos o sistema de login. Entre novamente com o mesmo e-mail ou a mesma rede social para manter seu progresso.",
        "nl": "We hebben het inlogsysteem bijgewerkt. Log opnieuw in met hetzelfde e-mailadres of hetzelfde social account om je voortgang te behouden.",
        "de": "Wir haben das Anmeldesystem aktualisiert. Melde dich bitte erneut mit derselben E-Mail-Adresse oder demselben sozialen Netzwerk an, um deinen Fortschritt zu behalten.",
        "fr": "Nous avons mis à jour le système de connexion. Reconnectez-vous avec la même adresse e-mail ou le même réseau social pour conserver votre progression.",
        "pt": "Atualizámos o sistema de início de sessão. Inicie sessão novamente com o mesmo e-mail ou a mesma rede social para manter o seu progresso.",
        "ru": "Мы обновили систему входа. Пожалуйста, войдите ещё раз с тем же email или через ту же соцсеть, чтобы сохранить прогресс.",
        "ko": "로그인 시스템이 변경되었습니다. 진행 상황을 유지하려면 기존과 동일한 이메일 또는 소셜 계정으로 다시 로그인해 주세요.",
        "ja": "ログインシステムを更新しました。進行状況を引き継ぐため、これまでと同じメールアドレスまたはソーシャルアカウントでもう一度ログインしてください。",
        "zh": "我们已更新登录系统。请使用原来的邮箱或社交账号重新登录，以保留你的进度。",
        "pl": "Zaktualizowaliśmy system logowania. Zaloguj się ponownie tym samym adresem e-mail lub tym samym kontem społecznościowym, aby zachować postępy.",
        "ua": "Ми оновили систему входу. Будь ласка, увійдіть ще раз із тим самим email або через ту саму соцмережу, щоб зберегти прогрес."
    },
    "auth_error_invalid_email": {
        "en": "Please enter a valid email address.",
        "es": "Introduce una dirección de correo válida.",
        "it": "Inserisci un indirizzo email valido.",
        "pt_br": "Digite um endereço de e-mail válido.",
        "nl": "Voer een geldig e-mailadres in.",
        "de": "Bitte gib eine gültige E-Mail-Adresse ein.",
        "fr": "Veuillez saisir une adresse e-mail valide.",
        "pt": "Introduza um endereço de e-mail válido.",
        "ru": "Введите корректный email.",
        "ko": "올바른 이메일 주소를 입력해 주세요.",
        "ja": "有効なメールアドレスを入力してください。",
        "zh": "请输入有效的电子邮箱地址。",
        "pl": "Wpisz poprawny adres e-mail.",
        "ua": "Введіть коректний email."
    },
    "auth_error_wrong_credentials": {
        "en": "Incorrect email or password.",
        "es": "Correo o contraseña incorrectos.",
        "it": "Email o password non corretti.",
        "pt_br": "E-mail ou senha incorretos.",
        "nl": "Onjuist e-mailadres of wachtwoord.",
        "de": "E-Mail oder Passwort ist falsch.",
        "fr": "E-mail ou mot de passe incorrect.",
        "pt": "E-mail ou palavra-passe incorretos.",
        "ru": "Неверный email или пароль.",
        "ko": "이메일 또는 비밀번호가 올바르지 않습니다.",
        "ja": "メールアドレスまたはパスワードが正しくありません。",
        "zh": "邮箱或密码不正确。",
        "pl": "Nieprawidłowy e-mail lub hasło.",
        "ua": "Невірний email або пароль."
    },
    "auth_error_email_not_verified": {
        "en": "Email not verified.",
        "es": "Correo no verificado.",
        "it": "Email non verificata.",
        "pt_br": "E-mail não verificado.",
        "nl": "E-mailadres niet geverifieerd.",
        "de": "E-Mail-Adresse nicht bestätigt.",
        "fr": "E-mail non vérifié.",
        "pt": "E-mail não verificado.",
        "ru": "Email не подтвержден.",
        "ko": "이메일이 인증되지 않았습니다.",
        "ja": "メールアドレスが確認されていません。",
        "zh": "邮箱尚未验证。",
        "pl": "E-mail niezweryfikowany.",
        "ua": "Email не підтверджено."
    },
    "auth_error_user_not_found": {
        "en": "No account with this email. You can create one.",
        "es": "No hay ninguna cuenta con este correo. Puedes crear una.",
        "it": "Nessun account con questa email. Puoi crearne uno.",
        "pt_br": "Não há conta com este e-mail. Você pode criar uma.",
        "nl": "Er is geen account met dit e-mailadres. Je kunt er een aanmaken.",
        "de": "Es gibt kein Konto mit dieser E-Mail-Adresse. Du kannst eines erstellen.",
        "fr": "Aucun compte avec cet e-mail. Vous pouvez en créer un.",
        "pt": "Não existe conta com este e-mail. Pode criar uma.",
        "ru": "Аккаунт с таким email не найден. Вы можете создать его.",
        "ko": "이 이메일로 등록된 계정이 없습니다. 새로 만들 수 있습니다.",
        "ja": "このメールアドレスのアカウントはありません。新規作成できます。",
        "zh": "没有使用该邮箱的账号。你可以创建一个。",
        "pl": "Nie ma konta z tym adresem e-mail. Możesz je utworzyć.",
        "ua": "Акаунт із таким email не знайдено. Ви можете створити його."
    },
    "auth_error_email_in_use": {
        "en": "An account with this email already exists. Please sign in.",
        "es": "Ya existe una cuenta con este correo. Inicia sesión.",
        "it": "Esiste già un account con questa email. Accedi.",
        "pt_br": "Já existe uma conta com este e-mail. Faça login.",
        "nl": "Er bestaat al een account met dit e-mailadres. Log in.",
        "de": "Es existiert bereits ein Konto mit dieser E-Mail-Adresse. Bitte melde dich an.",
        "fr": "Un compte avec cet e-mail existe déjà. Connectez-vous.",
        "pt": "Já existe uma conta com este e-mail. Inicie sessão.",
        "ru": "Аккаунт с таким email уже существует. Войдите в него.",
        "ko": "이 이메일로 등록된 계정이 이미 있습니다. 로그인해 주세요.",
        "ja": "このメールアドレスのアカウントはすでに存在します。ログインしてください。",
        "zh": "该邮箱已注册账号，请直接登录。",
        "pl": "Konto z tym adresem e-mail już istnieje. Zaloguj się.",
        "ua": "Акаунт із таким email уже існує. Увійдіть у нього."
    },
    "auth_error_weak_password": {
        "en": "Password must be at least 6 characters.",
        "es": "La contraseña debe tener al menos 6 caracteres.",
        "it": "La password deve contenere almeno 6 caratteri.",
        "pt_br": "A senha deve ter pelo menos 6 caracteres.",
        "nl": "Het wachtwoord moet minstens 6 tekens bevatten.",
        "de": "Das Passwort muss mindestens 6 Zeichen lang sein.",
        "fr": "Le mot de passe doit comporter au moins 6 caractères.",
        "pt": "A palavra-passe deve ter pelo menos 6 caracteres.",
        "ru": "Пароль должен быть не короче 6 символов.",
        "ko": "비밀번호는 6자 이상이어야 합니다.",
        "ja": "パスワードは6文字以上で入力してください。",
        "zh": "密码至少需要 6 个字符。",
        "pl": "Hasło musi mieć co najmniej 6 znaków.",
        "ua": "Пароль має містити щонайменше 6 символів."
    },
    "auth_error_too_many": {
        "en": "Too many attempts. Please try again later.",
        "es": "Demasiados intentos. Inténtalo de nuevo más tarde.",
        "it": "Troppi tentativi. Riprova più tardi.",
        "pt_br": "Muitas tentativas. Tente novamente mais tarde.",
        "nl": "Te veel pogingen. Probeer het later opnieuw.",
        "de": "Zu viele Versuche. Bitte versuche es später erneut.",
        "fr": "Trop de tentatives. Veuillez réessayer plus tard.",
        "pt": "Demasiadas tentativas. Tente novamente mais tarde.",
        "ru": "Слишком много попыток. Попробуйте позже.",
        "ko": "시도 횟수가 너무 많습니다. 잠시 후 다시 시도해 주세요.",
        "ja": "試行回数が多すぎます。しばらくしてからもう一度お試しください。",
        "zh": "尝试次数过多，请稍后再试。",
        "pl": "Zbyt wiele prób. Spróbuj ponownie później.",
        "ua": "Забагато спроб. Спробуйте пізніше."
    },
    "auth_error_network": {
        "en": "Network error. Please check your connection.",
        "es": "Error de red. Comprueba tu conexión.",
        "it": "Errore di rete. Controlla la connessione.",
        "pt_br": "Erro de rede. Verifique sua conexão.",
        "nl": "Netwerkfout. Controleer je verbinding.",
        "de": "Netzwerkfehler. Bitte überprüfe deine Verbindung.",
        "fr": "Erreur réseau. Vérifiez votre connexion.",
        "pt": "Erro de rede. Verifique a sua ligação.",
        "ru": "Ошибка сети. Проверьте подключение.",
        "ko": "네트워크 오류입니다. 연결 상태를 확인해 주세요.",
        "ja": "ネットワークエラーです。接続を確認してください。",
        "zh": "网络错误，请检查你的网络连接。",
        "pl": "Błąd sieci. Sprawdź połączenie.",
        "ua": "Помилка мережі. Перевірте підключення."
    },
    "auth_error_account_exists": {
        "en": "An account with this email already exists. Sign in with {method}, and we will link the accounts.",
        "es": "Ya existe una cuenta con este correo. Inicia sesión con {method} y vincularemos las cuentas.",
        "it": "Esiste già un account con questa email. Accedi con {method} e collegheremo gli account.",
        "pt_br": "Já existe uma conta com este e-mail. Entre com {method} e vincularemos as contas.",
        "nl": "Er bestaat al een account met dit e-mailadres. Log in met {method}, dan koppelen we de accounts.",
        "de": "Es existiert bereits ein Konto mit dieser E-Mail-Adresse. Melde dich mit {method} an, dann verknüpfen wir die Konten.",
        "fr": "Un compte avec cet e-mail existe déjà. Connectez-vous avec {method} et nous lierons les comptes.",
        "pt": "Já existe uma conta com este e-mail. Inicie sessão com {method} e iremos associar as contas.",
        "ru": "Аккаунт с таким email уже существует. Войдите через {method}, и мы свяжем аккаунты.",
        "ko": "이 이메일로 등록된 계정이 이미 있습니다. {method}(으)로 로그인하면 계정을 연결해 드립니다.",
        "ja": "このメールアドレスのアカウントはすでに存在します。{method}でログインすると、アカウントを連携します。",
        "zh": "该邮箱已注册账号。请使用 {method} 登录，我们会关联这两个账号。",
        "pl": "Konto z tym adresem e-mail już istnieje. Zaloguj się przez {method}, a połączymy konta.",
        "ua": "Акаунт із таким email уже існує. Увійдіть через {method}, і ми пов'яжемо акаунти."
    },
    "auth_error_account_exists_unknown": {
        "en": "An account with this email already exists. Sign in the way you did before (Google or email and password), and we will link this social account to it.",
        "es": "Ya existe una cuenta con este correo. Inicia sesión como lo hacías antes (con Google o con correo y contraseña) y vincularemos esta red social a tu cuenta.",
        "it": "Esiste già un account con questa email. Accedi come facevi prima (con Google oppure email e password) e collegheremo questo social al tuo account.",
        "pt_br": "Já existe uma conta com este e-mail. Entre como você fazia antes (com o Google ou com e-mail e senha) e vincularemos esta rede social à conta.",
        "nl": "Er bestaat al een account met dit e-mailadres. Log in zoals je dat eerder deed (met Google of met e-mail en wachtwoord), dan koppelen we dit social account eraan.",
        "de": "Es existiert bereits ein Konto mit dieser E-Mail-Adresse. Melde dich wie zuvor an (mit Google oder mit E-Mail und Passwort), dann verknüpfen wir dieses soziale Netzwerk damit.",
        "fr": "Un compte avec cet e-mail existe déjà. Connectez-vous comme avant (avec Google ou avec e-mail et mot de passe) et nous y lierons ce réseau social.",
        "pt": "Já existe uma conta com este e-mail. Inicie sessão como fazia antes (com o Google ou com e-mail e palavra-passe) e iremos associar esta rede social à conta.",
        "ru": "Аккаунт с таким email уже существует. Войдите так, как входили раньше (Google либо email и пароль), и мы привяжем к нему эту соцсеть.",
        "ko": "이 이메일로 등록된 계정이 이미 있습니다. 이전에 사용하던 방법(Google 또는 이메일과 비밀번호)으로 로그인하면 이 소셜 계정을 연결해 드립니다.",
        "ja": "このメールアドレスのアカウントはすでに存在します。これまでと同じ方法（Googleまたはメールアドレスとパスワード）でログインすると、このソーシャルアカウントを連携します。",
        "zh": "该邮箱已注册账号。请使用你之前的方式登录（Google 或邮箱和密码），我们会把这个社交账号关联上去。",
        "pl": "Konto z tym adresem e-mail już istnieje. Zaloguj się w dotychczasowy sposób (przez Google albo e-mailem i hasłem), a połączymy z nim to konto społecznościowe.",
        "ua": "Акаунт із таким email уже існує. Увійдіть так, як входили раніше (через Google або email і пароль), і ми прив'яжемо до нього цю соцмережу."
    },
    "auth_agree_prefix": {
        "en": "By continuing, you agree to be bound by our",
        "es": "Al continuar, aceptas nuestros",
        "it": "Continuando, accetti le nostre",
        "pt_br": "Ao continuar, você aceita nossos",
        "nl": "Door verder te gaan ga je akkoord met onze",
        "de": "Wenn du fortfährst, akzeptierst du unsere",
        "fr": "En continuant, vous acceptez nos",
        "pt": "Ao continuar, aceita os nossos",
        "ru": "Продолжая, вы принимаете наши",
        "ko": "계속하면 다음에 동의하는 것으로 간주됩니다:",
        "ja": "続行すると、次に同意したものとみなされます：",
        "zh": "继续即表示你同意我们的",
        "pl": "Kontynuując, akceptujesz nasze",
        "ua": "Продовжуючи, ви приймаєте наші"
    },
    "auth_agree_and": {
        "en": "and",
        "es": "y",
        "it": "e",
        "pt_br": "e",
        "nl": "en",
        "de": "und",
        "fr": "et",
        "pt": "e",
        "ru": "и",
        "ko": "및",
        "ja": "および",
        "zh": "和",
        "pl": "oraz",
        "ua": "і"
    },
    "auth_error_provider_invalid": {
        "en": "Could not verify the sign-in with this social network. The app settings for this provider are not configured correctly.",
        "es": "No se ha podido verificar el inicio de sesión con esta red social. Los ajustes de la aplicación de este proveedor no son correctos.",
        "it": "Non è stato possibile verificare l'accesso con questo social. Le impostazioni dell'app di questo provider non sono corrette.",
        "pt_br": "Não foi possível verificar o login com esta rede social. As configurações do aplicativo deste provedor estão incorretas.",
        "nl": "Het inloggen via dit sociale netwerk kon niet worden geverifieerd. De app-instellingen van deze provider zijn niet juist.",
        "de": "Die Anmeldung über dieses soziale Netzwerk konnte nicht überprüft werden. Die App-Einstellungen dieses Anbieters sind nicht korrekt.",
        "fr": "Impossible de vérifier la connexion via ce réseau social. Les paramètres de l'application de ce fournisseur sont incorrects.",
        "pt": "Não foi possível verificar o início de sessão com esta rede social. As definições da aplicação deste fornecedor estão incorretas.",
        "ru": "Не удалось подтвердить вход через эту соцсеть. Настройки приложения этого провайдера заданы неверно.",
        "ko": "이 소셜 네트워크를 통한 로그인을 확인할 수 없습니다. 해당 제공업체의 앱 설정이 올바르지 않습니다.",
        "ja": "このソーシャルネットワークでのログインを確認できませんでした。このプロバイダーのアプリ設定が正しくありません。",
        "zh": "无法验证通过该社交网络的登录。该登录方式的应用设置不正确。",
        "pl": "Nie udało się zweryfikować logowania przez ten serwis społecznościowy. Ustawienia aplikacji tego dostawcy są nieprawidłowe.",
        "ua": "Не вдалося підтвердити вхід через цю соцмережу. Налаштування застосунку цього провайдера задані невірно."
    },
    "auth_error_not_allowed": {
        "en": "This sign-in method is temporarily unavailable.",
        "es": "Este método de inicio de sesión no está disponible temporalmente.",
        "it": "Questo metodo di accesso non è temporaneamente disponibile.",
        "pt_br": "Este método de login está temporariamente indisponível.",
        "nl": "Deze inlogmethode is tijdelijk niet beschikbaar.",
        "de": "Diese Anmeldemethode ist vorübergehend nicht verfügbar.",
        "fr": "Cette méthode de connexion est temporairement indisponible.",
        "pt": "Este método de início de sessão está temporariamente indisponível.",
        "ru": "Этот способ входа временно недоступен.",
        "ko": "이 로그인 방법은 일시적으로 사용할 수 없습니다.",
        "ja": "このログイン方法は現在ご利用いただけません。",
        "zh": "该登录方式暂时不可用。",
        "pl": "Ta metoda logowania jest chwilowo niedostępna.",
        "ua": "Цей спосіб входу тимчасово недоступний."
    },
    "auth_error_generic": {
        "en": "Sign-in failed. Please try again.",
        "es": "No se ha podido iniciar sesión. Inténtalo de nuevo.",
        "it": "Accesso non riuscito. Riprova.",
        "pt_br": "Não foi possível entrar. Tente novamente.",
        "nl": "Inloggen is mislukt. Probeer het opnieuw.",
        "de": "Anmeldung fehlgeschlagen. Bitte versuche es erneut.",
        "fr": "La connexion a échoué. Veuillez réessayer.",
        "pt": "Não foi possível iniciar sessão. Tente novamente.",
        "ru": "Не удалось войти. Попробуйте ещё раз.",
        "ko": "로그인하지 못했습니다. 다시 시도해 주세요.",
        "ja": "ログインできませんでした。もう一度お試しください。",
        "zh": "登录失败，请重试。",
        "pl": "Logowanie nie powiodło się. Spróbuj ponownie.",
        "ua": "Не вдалося увійти. Спробуйте ще раз."
    },
    "auth_method_password": {
        "en": "email and password",
        "es": "correo y contraseña",
        "it": "email e password",
        "pt_br": "e-mail e senha",
        "nl": "e-mail en wachtwoord",
        "de": "E-Mail und Passwort",
        "fr": "e-mail et mot de passe",
        "pt": "e-mail e palavra-passe",
        "ru": "email и пароль",
        "ko": "이메일과 비밀번호",
        "ja": "メールアドレスとパスワード",
        "zh": "邮箱和密码",
        "pl": "e-mail i hasło",
        "ua": "email і пароль"
    },
    "auth_method_google": {
        "en": "Google",
        "es": "Google",
        "it": "Google",
        "pt_br": "Google",
        "nl": "Google",
        "de": "Google",
        "fr": "Google",
        "pt": "Google",
        "ru": "Google",
        "ko": "Google",
        "ja": "Google",
        "zh": "Google",
        "pl": "Google",
        "ua": "Google"
    },
    "auth_method_facebook": {
        "en": "Facebook",
        "es": "Facebook",
        "it": "Facebook",
        "pt_br": "Facebook",
        "nl": "Facebook",
        "de": "Facebook",
        "fr": "Facebook",
        "pt": "Facebook",
        "ru": "Facebook",
        "ko": "Facebook",
        "ja": "Facebook",
        "zh": "Facebook",
        "pl": "Facebook",
        "ua": "Facebook"
    },
    "install_descr": {
        "en": "Click the install button in the address bar, or refresh the page and try again.",
        "es": "Haz clic en el botón de instalación en la barra de direcciones, o actualiza la página e inténtalo de nuevo.",
        "it": "Clicca sul pulsante di installazione nella barra degli indirizzi, oppure aggiorna la pagina e riprova.",
        "pt_br": "Clique no botão de instalação na barra de endereços, ou atualize a página e tente novamente.",
        "nl": "Klik op de installatieknop in de adresbalk, of ververs de pagina en probeer opnieuw.",
        "de": "Klicken Sie auf die Installations-Schaltfläche in der Adressleiste, oder aktualisieren Sie die Seite und versuchen Sie es erneut.",
        "fr": "Cliquez sur le bouton d'installation dans la barre d'adresse, ou rafraîchissez la page et réessayez.",
        "pt": "Clique no botão de instalação na barra de endereços, ou atualize a página e tente novamente.",
        "ru": "Нажмите на кнопку установки в адресной строке либо обновите страницу и попробуйте еще раз",
        "ko": "주소 표시줄의 설치 버튼을 클릭하거나 페이지를 새로고침하고 다시 시도하세요.",
        "ja": "アドレスバーのインストールボタンをクリックするか、ページを更新してもう一度試してください。",
        "zh": "点击地址栏中的安装按钮，或刷新页面后重试。",
        "pl": "Kliknij przycisk instalacji na pasku adresu lub odśwież stronę i spróbuj ponownie.",
        "ua": "Натисніть кнопку встановлення в адресному рядку або оновіть сторінку і спробуйте ще раз."
    }
}

function transformToOldFormat(newTranslations) {
    const oldFormat = {};
    Object.keys(newTranslations).forEach(key => {
        Object.keys(newTranslations[key]).forEach(lang => {
            if (!oldFormat[lang]) {
                oldFormat[lang] = {};
            }
            oldFormat[lang][key] = newTranslations[key][lang];
        });
    });
    return oldFormat;
}

export default transformToOldFormat(translations2);